export const visit = (vm, at) => {
at({ "en": { "crm_data": null } });
};